/* tslint:disable */

/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface DeleteResourceRequest
 */
export interface DeleteResourceRequest {
	/**
	 * RID of the resource
	 * @type {string}
	 * @memberof DeleteResourceRequest
	 */
	rID: string;
}

/**
 * Check if a given object implements the DeleteResourceRequest interface.
 */
export function instanceOfDeleteResourceRequest(value: object): boolean {
	let isInstance = true;
	isInstance = isInstance && 'rID' in value;

	return isInstance;
}

export function DeleteResourceRequestFromJSON(json: any): DeleteResourceRequest {
	return DeleteResourceRequestFromJSONTyped(json, false);
}

export function DeleteResourceRequestFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): DeleteResourceRequest {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		rID: json['RID'],
	};
}

export function DeleteResourceRequestToJSON(value?: DeleteResourceRequest | null): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		RID: value.rID,
	};
}
